module.exports = __webpack_public_path__ + "img/panel-right-arrow.c12df176.svg";